<p-blockUI [target]="pnl" [blocked]="blocked">
    <i class="pi pi-lock" style="font-size: 4rem"></i>
</p-blockUI>

<p-fieldset  #pnl>
    <ng-template pTemplate="header">Compras a proveedores</ng-template>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2" (click)="goBackClose()"></button>
        </ng-template>

   
    </p-toolbar>

    <div class="card">
        <div class="p-grid">
    
            <div class="p-col-12 p-md-6">
                <div class="card">
                    <div class="p-fluid">
                        <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                            
                            <label for="opt">{{lbl_year}}</label>
                            <div class="p-col-6 p-md-10">
                                <p-dropdown   [options]="listYears" [(ngModel)]="selectedYearVO"  optionLabel="descrip" [showClear]="true" placeholder="{{lbl_select}} {{lbl_year}}" ></p-dropdown>
                            </div>
                        </div>
                        <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                            <label for="opt">{{lbl_status}}</label>
                            <div class="p-col-6 p-md-10">
                                <p-dropdown   [options]="listStatus" [(ngModel)]="selectedStatus"  optionLabel="descrip" [showClear]="true" placeholder="{{lbl_status}}" ></p-dropdown>                                                
                            </div>
                        </div>
                        <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="p-mr-2 p-mb-2">
                                <p-button label="{{lbl_search}}"  icon="pi pi-search" (onClick)="search()" loading="loadingSearch"></p-button>
                            </div>
                        </div>
                        
                    
                    </div>
                </div>

            </div>
            <div class="col-12 lg:col-6">
                <p-toast></p-toast>
                <div class="card ">
                    <div class="grid p-fluid">
                        <div class="col-66 lg:col-6">
                            <div class="card height-100">
                                
                                <p-table #dt1 [value]="listPurchasingSum"  [rows]="15" [paginator]="true" [globalFilterFields]="['TipoReporte.P_REPORT_NAME','executionReport.estatus.EXECUTION_DESCR']"
                                         [rowHover]="true" dataKey="id" [filterDelay]="0"
                                        styleClass="p-datatable-customers"
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
                                        <ng-template pTemplate="caption">

                                            
                                            <span class="p-input-icon-left">
                                             
                                                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS" tooltipPosition="bottom"></button>
                                             
                                            </span>
                                        </ng-template>
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th >{{lbl_zone}}</th>
                                            <th >Country Id</th>
            
                                            <th  style="text-align: center">Amount</th>
                                            <th  style="text-align: center">4%</th>
                                            <th style="width:4rem"></th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-value>
                                        <tr>
                                            <td><span class="p-column-title"></span>
                                                {{value.name}}
                                            </td>
                                            <td><span class="p-column-title"></span>
                                                {{value.countryId}}
                                            </td>
                                             
                                            <td style="text-align: center"><span class="p-column-title"></span>
                                                {{value.amount | currency:value.currency}}
                                            </td>
                                            <td style="text-align: center"><span class="p-column-title"></span>
                                                {{value.amount * 0.04 | currency:value.currency}}
                                            </td>
                                            <td style="width:4rem">
                                                <button  type="button" pButton pRipple icon="pi pi-search" (click)="redirectDetail(value)" ></button>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="summary">
                                        <div class="flex align-items-center justify-content-between">
                                            {{lbl_total}}  {{listPurchasingSum ? listPurchasingSum.length : 0 }}.
                                        </div>
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>  
                        
                        
                    </div>
                </div>
        
        
                <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
            </div>
        </div>
    </div>

</p-fieldset>

